export const GET_ICEPACKS_STATES = 'icepacks-states/GET_ICEPACKS_STATES';
export const getIcepacksStatesAction = payload => ({
	type: GET_ICEPACKS_STATES,
	payload,
});

export const SET_ICEPACKS_STATES = 'icepacks-states/SET_ICEPACKS_STATES';
export const setIcepacksStatesAction = payload => ({
	type: SET_ICEPACKS_STATES,
	payload,
});

export const SET_PAGINATION = 'icepacks-states/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const SET_IS_ICEPACKS_STATES_LOADING = 'icepacks-states/SET_IS_ICEPACKS_STATES_LOADING';
export const setIsIcepacksStatesLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_STATES_LOADING,
	payload,
});

export const RESET_STATE = 'icepacks-states/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
